import React, { useState } from "react";
import { useLoader } from "../../Common/GeneralLoader/GeneralLoaderProvider";
import { addRecipientApi } from "../../../api/api";
import { drupalSettings } from "../../../utils/config";

export const ConfirmDetails = ({ setStep, payload, setPayload }) => {
  const { showLoader, hideLoader } = useLoader(); // Destructure isLoading, showLoader, and hideLoader
  const [error, setError] = useState(false);

  const formErrors = {
    technical_error: Drupal.t(
      "Sorry, there was an error. Please try again later or reach out to support@nautzero.com."
    ),
  };

  const handleSubmit = (event) => {
    event.preventDefault();

    let isValid = true; // Flag to track if all validations pass

    // If any validation failed, prevent form submission
    if (!isValid) {
      return;
    }

    setError(false);

    showLoader();

    const requestPayload = {
      payload: { ...payload?.beneficiaryFormData },
      recipient_name: payload?.beneficiaryFormData?.beneficiary?.bank_details?.account_name,
      uid: drupalSettings?.user?.user_id || drupalSettings?.user?.uid,
    };

    (async () => {
      try {
        const response = await addRecipientApi(requestPayload);
        // SCA required: /rest/add/recipient returns 200 with { result: false, message: { code: 403, sca_session_code, ... } }
        if (!response?.result && response?.message?.code === 403) {
          const scaSessionCode =
            response?.message?.sca_session_code ??
            response?.message?.session_code ??
            response?.message?.scaSessionCode ??
            response?.sca_session_code;
          if (scaSessionCode) {
            setPayload((prev) => ({
              ...prev,
              scaSessionCode,
              _addRecipientRequest: requestPayload,
            }));
            setStep(2.1);
            return;
          }
        }
        if (!response?.result) {
          setError(formErrors?.technical_error);
          return;
        }
        jQuery(".view-bank-recipient").trigger("RefreshView");
        setStep(0);
      } catch (err) {
        // HTTP 403 with x-sca-session-code header or body (alternative to 200 + result: false)
        const scaSessionCode =
          err?.response?.headers?.["x-sca-session-code"] ??
          err?.response?.data?.message?.sca_session_code ??
          err?.response?.data?.message?.session_code ??
          err?.response?.data?.sca_session_code;
        if (err?.response?.status === 403 && scaSessionCode) {
          setPayload((prev) => ({
            ...prev,
            scaSessionCode,
            _addRecipientRequest: requestPayload,
          }));
          setStep(2.1);
          return;
        }
        setError(formErrors?.technical_error);
      } finally {
        hideLoader();
      }
    })();
  };

  return (
    <>
      <div className="add-recipient-header">
        <h4 className="add-recipient-title">Add a New <span className="yellow">Recipient</span></h4>
      </div>
      <div className="add-recipient-body-content">
        <form className="confirm-details-form">
          <div className="form--item form--group">
            <label>Recipient Type:</label>
            <strong>{payload?.beneficiaryFormData?.beneficiary?.entity_type}</strong>
          </div>
          {/* <div className="form--item form--group mt--2">
            <label>Transfer Method:</label>
            <strong>{payload?.beneficiaryFormData?.payment_methods?.join(", ")}</strong>
          </div> */}
          {/* {payload?.beneficiaryFormData?.payment_methods?.includes("LOCAL") ? <div className="form--item form--group">
            <label>(IF LOCAL) Clearing System:</label>
            <strong>--</strong>
          </div> : null} */}
          {
            Object.entries(payload?.beneficiaryFormData?.beneficiary?.bank_details || {}).map(([key, value]) => {
              if (key.startsWith("account_routing_type")) {
                // extract the index (e.g., 1, 2...) to match with value
                const index = key.replace("account_routing_type", "");
                const typeLabel = value.split("_")
                  .map(word => word.charAt(0).toUpperCase() + word.slice(1))
                  .join(" "); // like "bank_code"
                const typeValue = payload?.beneficiaryFormData?.beneficiary?.bank_details?.[`account_routing_value${index}`];

                return (
                  <div key={key} className="form--item form--group">
                    <label>{typeLabel == "Aba" ? "Account Routing Number" : typeLabel}:</label>
                    <strong>{typeValue}</strong>
                  </div>
                );
              }

              // skip the "value" keys since they are already paired above
              if (key.startsWith("account_routing_value")) return null;

              // normal fields
              const label = key
                .split("_")
                .map(word => word.charAt(0).toUpperCase() + word.slice(1))
                .join(" ");

              return (
                <div key={key} className="form--item form--group">
                  <label>{label}:</label>
                  <strong>{value}</strong>
                </div>
              );
            })
          }
          {/* <div className="form--item form--group mt--2">
            <label>Account Holder's Full Name:</label>
            <strong>{payload?.beneficiaryFormData?.beneficiary?.entity_type == "COMPANY" ? payload?.beneficiaryFormData?.beneficiary?.company_name : payload?.beneficiaryFormData?.beneficiary?.first_name + " " + payload?.beneficiaryFormData?.beneficiary?.last_name}</strong>
          </div> */}
          <div className="form--item form--group">
            <label>Recipient's Address:</label>
            <strong>
              {payload?.beneficiaryFormData?.beneficiary?.address ? Object.values(payload?.beneficiaryFormData?.beneficiary?.address)?.reverse()?.join(", ") : "--"}
            </strong>
          </div>
          {error && (
            <div className="popup-has-error">
              <div className="error_messages">{error}</div>
            </div>
          )}
          <div className="add-recipient-actions">
            <button className="secondary__btn" type="submit" onClick={() => setStep(1)}>
              Edit
            </button>
            <button className="primary__btn" type="submit" onClick={handleSubmit}>
              Submit
            </button>
          </div>
        </form>
      </div>
    </>
  );
};
